import { lang } from '@umu/ukit-lang';
/**
 * @description 树的搜索框
 */
import React, { createRef, useState } from 'react';
import { If } from 'common/src/components';
import { Iconfont as IconFont } from '@umu/umu-design';

import './departmentSearch.scss';

interface IProps {
    placeholder?: string;
    searchKeyword?: string;
    searchCallback?(keywords: string): void;
}

export const DepartmentSearch = (props: IProps) => {
    const placeholder = props.placeholder || lang('搜索_Search');
    const [keywords, setkeywords] = useState(props.searchKeyword || '');
    const searchInputRef: any = createRef();
    const searchInputKeywordRef: any = createRef();
    const setParentCallback = (value: string) => {
        if (props.searchCallback) {
            props.searchCallback(value);
        }
    };
    const onChange = () => {
        const value = searchInputKeywordRef.current!.value;
        setkeywords(value);
    };

    const onKeyUp = (e: React.KeyboardEvent) => {
        switch (e.keyCode) {
            case 13:
                setParentCallback(keywords);
                break;
            default:
                break;
        }
    };

    const onClearBtnClick = () => {
        setkeywords('');
        setParentCallback('');
    };

    return (
        <div className="department-header-search-input" ref={searchInputRef}>
            <div className="search-input-box">
                <input
                    type="text"
                    ref={searchInputKeywordRef}
                    className="search-input-keyword"
                    placeholder={placeholder}
                    maxLength={100}
                    onChange={onChange}
                    onKeyUp={onKeyUp}
                    value={keywords}
                />
                <If condition={!keywords}>
                    <i className="icon icon-search"></i>
                </If>
                <If condition={!!keywords}>
                    <IconFont type="Delete2" className="icon-member-clear" onClick={onClearBtnClick} />
                </If>
            </div>
        </div>
    );
};
